import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Divider, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import EditeButton from "../../general/antd/edite-button";
import PageHeader from "../../general/layout/page-header";
import styles from "./style.module.scss";
import RefreshBtn from "../table-components/actions/refresh-btn";
import { useContext } from "react";
import AppContext from "../../../context/app/context";

interface Props {
  title?: string;
  subtitle?: string;
  buttonName?: string;
  navigate?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
  onRefresh?: () => void;
  loading?: boolean;
  actionsDisabled?: boolean;
  headerExtra?: React.ReactNode;
}

const PageDetails: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { screenSize } = useContext(AppContext);

  return (
    <>
      <div className={styles.container}>
        <PageHeader
          title={t(`${props.title}`)}
          subTitle={t(`${props.subtitle}`)}
          extra={props.headerExtra}
        />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              display: "flex",
              gap: "4px",
              flexDirection:
                screenSize !== "laptopOrDesktop" ? "column" : "row",
            }}
          >
            {props?.buttonName && (
              <EditeButton
                onClick={props.onClick}
                className={styles.button}
                disabled={props.actionsDisabled}
              >
                {t(`${props.buttonName}`)}
              </EditeButton>
            )}
            {props?.onRefresh && (
              <>
                <RefreshBtn
                  className={styles.button}
                  loading={props.loading}
                  disabled={props.actionsDisabled}
                  onClick={props.onRefresh}
                >
                  {t("refresh")}
                </RefreshBtn>
              </>
            )}
          </div>
          <Tooltip placement="topRight" title={t("go_to_back")}>
            {!props?.navigate && (
              <Button
                onClick={() => navigate(-1)}
                type="primary"
                style={{ width: "5rem", marginBottom: "1rem" }}
                icon={
                  <ArrowLeftOutlined
                    spin={false}
                    style={{ fontSize: "1.2rem" }}
                  />
                }
              />
            )}
          </Tooltip>
        </div>

        {props.children}
      </div>
    </>
  );
};

export default PageDetails;
